import Vue from "vue";
import Component from "vue-class-component";
import NoUISlider from "nouislider";

import DataHelper from "@Scripts/Common/DataHelper";

@Component({ name: "ArchiveImageSearchBox" })
export default class ArchiveImageSearchBox extends Vue {
    public searchFilter: string = this.topicFilter !== null ? "" : (<any>window).App.bag.Search;
    public yearStartFilter: number = this.topicFilter !== null ? this.yearMin : (<any>window).App.bag.YearStart;
    public yearEndFilter: number = this.topicFilter !== null ? this.yearMax : (<any>window).App.bag.YearEnd;
    public isButtonActive: boolean = false;

    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get topics() {
        return (<any>window).App.bag.Topics;
    }

    get topicFilter() {
        return (<any>window).App.bag.TopicFilter;
    }

    get yearMax() {
        return (<any>window).App.bag.YearMax;
    }

    get yearMin() {
        return (<any>window).App.bag.YearMin;
    }

    public mounted() {
        this.setYearSlider();
    }

    public setYearSlider() {
        let slider = document.getElementById("DateSlider") as NoUISlider.Instance,
            self = this;

        if (slider) {
            NoUISlider.create(slider, {
                start: [this.yearStartFilter, this.yearEndFilter],
                connect: true,
                range: {
                    "min": [this.yearMin],
                    "max": [this.yearMax]
                },
                format: {
                    to: function (value) {
                        return DataHelper.convertStringToNumber(parseFloat(value).toFixed(0));
                    },
                    from: function (value) {
                        return value;
                    }
                }
            });
        }

        slider.noUiSlider.on("update", function (values, handle) {
            self.yearStartFilter = values[0];
            self.yearEndFilter = values[1];
        });
    }

    public async setImageSearch() {
        this.validationErrors = [];

        try {
            let response = await this.$store.dispatch("archiveImageStore/setImageSearch", {
                searchText: this.searchFilter,
                yearStart: this.yearStartFilter,
                yearEnd: this.yearEndFilter
            });

            if (response && response.status === 200) {
                window.location.href = response.data;
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    for (var propertyName in error.response.data) {
                        if (error.response.data.hasOwnProperty(propertyName)) {
                            for (let message of error.response.data[propertyName]) {
                                this.validationErrors.push({ message: message });
                            }
                        }
                    }
                }
            }
        }
    }

    public setSearchArchive() {
        this.isButtonActive = !this.isButtonActive;
        (<any>this).$refs.searchBox.classList.toggle("show");
    }

    public archiveImageList(topicName: string) {
        window.location.href = this.routes.ArchiveImage_List + "?topic=" + topicName;
    }
};